/**
 * Base URL for the school document/framework multipart uploads, which go
 * through fetch() directly instead of apiRequest. Upgrades to https when the
 * page itself is served over https.
 */
export function getSchoolApiBase(): string {
  const RAW = process.env.EXPO_PUBLIC_API_URL || 'http://localhost:8000';
  const hasScheme = /^https?:\/\//i.test(RAW);
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    if (!hasScheme) return `https://${RAW}`;
    if (RAW.toLowerCase().startsWith('http://')) return RAW.replace(/^http:\/\//i, 'https://');
  }
  return hasScheme ? RAW : `http://${RAW}`;
}
